import { useMemo, useState } from 'react';
export const useOpen = ({ open: externalOpen, setOpen: externalSetOpen }) => {
    const [internalOpen, setInternalOpen] = useState(false);
    const open = useMemo(() => (externalOpen !== undefined ? externalOpen : internalOpen), [externalOpen, internalOpen]);
    const setOpen = useMemo(() => (externalSetOpen !== undefined ? externalSetOpen : setInternalOpen), [externalSetOpen, setInternalOpen]);
    return [open, setOpen];
};
